import React, { useState } from 'react';
import MemberList from '../components/MemberList';
import AddInviteMembers from '../components/AddInviteMembers';

/**
 * MembersTab - Self-Contained Members Management Component
 *
 * Props:
 * - voProvider: SquadDetailsProvider instance (required)
 *
 * Features:
 * - Display member list with roles and actions
 * - Add/invite members modal
 * - Remove members (admin only)
 * - Change member roles (admin only)
 * - Accept/reject join requests (admin only)
 *
 * This component is a thin wrapper around existing components:
 * - MemberList: Handles member display and management
 * - AddInviteMembers: Handles adding/inviting new members
 *
 * Both components are already self-contained and receive voProvider.
 */

const MembersTab = ({ voProvider }) => {
  // Modal state for adding/inviting members
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [invitationId, setInvitationId] = useState(null);
  const [reinviteUserId, setReinviteUserId] = useState(null);

  // Guard: Return loading state if voProvider not available
  if (!voProvider) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg p-8 text-center">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
        </div>
      </div>
    );
  }

  const handleAddMemberClick = () => {
    setInvitationId(null);
    setShowAddMemberModal(true);
  };

  const handleInvitedClick = (invId, userId) => {
    setInvitationId(invId || null);
    setReinviteUserId(userId || null);
    setShowAddMemberModal(true);
  };

  const handleCloseAddMemberModal = () => {
    setShowAddMemberModal(false);
    setInvitationId(null);
    setReinviteUserId(null);
  };

  return (
    <>
      {/* Member List - Self-contained component */}
      <MemberList
        voProvider={voProvider}
        onAddMemberClick={handleAddMemberClick}
        onInvitedClick={handleInvitedClick}
        showActions={true}
      />

      <AddInviteMembers
        voProvider={voProvider}
        isOpen={showAddMemberModal}
        onClose={handleCloseAddMemberModal}
        invitationId={invitationId}
        reinviteUserId={reinviteUserId}
      />
    </>
  );
};

export default MembersTab;
